<template>
  <v-container v-if="cargando">
    <v-btn color="orange" @click="volver"  left dark> Volver </v-btn>
    <h4 style="margin-top: 40px">Nuevo Usuario</h4>
    <v-form>
      <v-text-field
        v-model="correo"
        :rules="reglaCorreo"
        label="Correo"
        append-icon="mdi-account"
        required
      >
      </v-text-field>
      <v-text-field
        v-model="contrasena"
        :type="verContrasena ? 'text' : 'password'"
        label="Contraseña"
        :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
        required
        :rules="reglaContrasena"
        @click:append="verContrasena = !verContrasena"
      >
      </v-text-field>
      <v-text-field
        v-model="nombre"
        label="Nombre"
        append-icon="mdi-clipboard-account"
        :rules="reglaTexto"
        required
      >

      </v-text-field>
      <v-switch v-model="administrador"   label="Administrador"></v-switch>
      <v-select
        v-if="!administrador"
        style="padding-bottom: 20px"
        v-model="grupoAcceso"
        :items="arrayNombresGruposAccesos"
        menu-props="auto"
        label="Selecciona un Grupo"
        hide-details
        :rules="reglaTexto"
        prepend-icon="mdi-group"
        single-line
      ></v-select>
      <v-switch v-if="!administrador" v-model="compartir"   label="Compartir Archivo"></v-switch>
      <v-switch v-model="bloqueado"   label="Bloqueado"></v-switch>
      <v-btn color="green" @click="nuevoUsuario" absolute center dark>
        Añadir
        <v-icon right dark> mdi-account-plus </v-icon>
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import ApiZD from "../apiZonaDeDescargas";
export default {
  data() {
    return {
      correo: "",
      nombre: "",
      administrador: false,
      bloqueado: false,
      arrayAccesos: [],
      compartir: false,
      arrayAccesosSeleccionadosPorUsuario: [],
      contrasena: "",
      reglaCorreo: [
        (v) => !!v || "Correo Requerido",
        (v) => /.+@.+\..+/.test(v) || "Correo no valido",
      ],
      reglaContrasena: [
        (v) => !!v || "Correo Requerido",
        (v) => (v || "").indexOf(" ") < 0 || "No spaces are allowed",
        (v) => (v || "").length > 7|| "Se necesitan 8 caracteres minimo",
      ],
      reglaTexto: [(v) => !!v || "Nombre Requerido"],
      verContrasena: false,
      grupoAcceso: "",
      arrayGruposAccesos: [],
      arrayNombresGruposAccesos:[],
      cargando: false,
      idGrupoAcceso:""
    };
  },
  methods: {
    volver() {
      this.$router.go(-1);
    },

    obtenerGruposAccesos() {
      ApiZD.obtenerGrupoAccesos()
        .then((resultado) => {
          this.arrayGruposAccesos = resultado.data.grupos;
          resultado.data.grupos.forEach((grupo) => {
            this.arrayNombresGruposAccesos.push(grupo["nombre"]);
          });
        })
        .catch((e) => {
          this.$router.push({ path: "/principal" });
        })
        .finally(() => {
          this.cargando = true;
        });
    },
    //Se crea un nuevo usuario
    nuevoUsuario() {
      if (
        this.correo == "" ||
        this.contrasena == "" ||
        this.nombre == "" ||
        !/.+@.+\..+/.test(this.correo) ||
        this.contrasena.length < 7||
        this.administrador == false && this.grupoAcceso == ""
      ) {
        this.$root.$dialogo.activarDialogo(
          "Fallo datos",
          "Rellena correctamente todos los datos para poder registrarte",
          ["OK"]
        );
      } else {
        this.obtenerIdDelNombreDelGrupo(this.grupoAcceso)
        if (this.administrador){
          this.grupoAcceso = null;
          this.compartir = true
        }
        ApiZD.nuevoUsuario(
          this.correo,
          this.contrasena,
          this.nombre,
          this.administrador,
          this.bloqueado,
          this.idGrupoAcceso,
          this.compartir
        )
          .then(() => {
            this.$router.push({ path: "/principalUsuarios" });
          })
          .catch((e) => {
            if (e.status === 500) {
              this.$root.$dialogo.activarDialogo(
                "Error al registrar usuario",
                "Este correo ya se encuentra en uso, utiliza otro distinto para registrarlo",
                ["OK"]
              );
            }
          })
      }
    },

    obtenerIdDelNombreDelGrupo(nombreGrupo) {
      this.arrayGruposAccesos.forEach((grupo) =>{
        if(grupo['nombre'] == nombreGrupo)
          return this.idGrupoAcceso = grupo['id'];
      })
    },
  },
  created() {
    this.obtenerGruposAccesos();
  },
};
</script>

<style scoped>

.custom-red {
  color: red;
}

</style>